import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

interface Props {
  state: { success?: boolean; error?: boolean; warn?: boolean; info?: boolean };
  message: string;
}
export const setToaster = (props: Props): any => {
  if (props.state.success != null && props.state.success === true) {
    toast.success(props.message, {
      //position: toast.POSITION.TOP_CENTER,
    });
    return;
  } else if (props.state.error != null && props.state.error === true) {
    toast.error(props.message, {
      //position: toast.POSITION.TOP_CENTER,
    });
    return;
  } else if (props.state.warn != null && props.state.warn === true) {
    toast.warn(props.message, {
      //position: toast.POSITION.TOP_CENTER,
    });
  } else if (props.state.info != null && props.state.info === true) {
    toast.info(props.message, {
      //position: toast.POSITION.TOP_CENTER,
    });
    return;
  }

  toast(props.message, {
    //position: toast.POSITION.TOP_CENTER,
  });
};
